// extracted by mini-css-extract-plugin
export var dividerLine = "_62-3";
export var itemImage = "_62-9";
export var lightDivider = "_62-4";
export var modalContent = "_62-5";
export var modalContentCompact = "_62-6";
export var productCard = "_62-a";
export var productImage = "_62-b";
export var productImageCompact = "_62-7";
export var productImagePlaceholder = "_62-c";
export var productImagePlaceholderCompact = "_62-8";
export var progressBarBackground = "_62-1";
export var progressBarContainer = "_62-0";
export var progressBarFill = "_62-2";